<div class="entity-overview">
  <h2 class="entity-overview-title">{{ title() }}</h2>
  <div class="entity-overview-stats">
    @for (stat of stats(); track stat.label) {
      <app-stats-card
        [value]="stat.value"
        [label]="stat.label"
        [variant]="stat.variant || 'primary'"
      />
    }
  </div>
</div>
